{
  "dodo.common.close": "Close",
  "dodo.common.continue": "Continue",
  "dodo.errors.idle.action": "Probeer het nog eens.",
  "dodo.errors.idle.headline": "Dienst momenteel niet beschikbaar",
  "dodo.errors.idle.line1": "Probeer het later nog eens.",
  "dodo.feedback.comments": "Please share any additional comments, suggestions or improvement opportunities. How it can be more valuable to you?",
  "dodo.feedback.description": "Your feedback is very important, so we can improve our services",
  "dodo.feedback.disclaimer.headline": "No worries, your answer will be anonymised!",
  "dodo.feedback.disclaimer.line1": "Your name and e-mail won't be linked to your answer.",
  "dodo.feedback.headline": "On a scale from 1-5, how satisfied are you with {subject}?",
  "dodo.feedback.placeholder": "Write your feedback here",
  "dodo.feedback.satisfied": "Very satisfied",
  "dodo.feedback.success.line1": "Thanks for using and contributing to our services.",
  "dodo.feedback.success.title": "Your feedback was successfully registered",
  "dodo.feedback.unsatisfied": "Very unsatisfied",
  "dodo.maintenance.actionText": "Terug naar de startpagina",
  "dodo.maintenance.description": "Soms hebben we een korte pauze nodig om essentieel onderhoud en/of upgrades aan onze diensten uit te voeren. We waarderen uw begrip.",
  "dodo.maintenance.headline": "Sorry, we zijn nu bezig met gepland onderhoud"
}